<div>
  <span class="date">{{ date | date: 'fullDate':'': 'nl-NL'}}</span>
  <span style="width: 70px">{{ date | date: 'HH:mm:ss': '': 'nl-NL'}}</span>
</div>


